import React, { } from 'react'

import AuthPanel from '../AuthPanel'

// Body swapped for the canonical lib-core auth panel. The redux-form
// LoginWithEmailForm and the loginWithEmail action wiring are superseded;
// the route ('home/welcome/login/email') is unchanged.
const Login = () => {
  return <AuthPanel initialState="login" />
}

export default Login
